<template>
	<div>
		<div class="candidate-view">
			<div class="left-side">
				<router-link to="/screenings" class="go-back">
					<SvgIcon icon="arrow-back" />
				</router-link>
				<div class="profile">
					<h1 class="name" v-if="firstName">{{ firstName }}</h1>
					<h1 class="name" v-else>{{ $t('tenant-profile.unknown-name.label') }}</h1>
					<p class="age">{{ addressLineOne }}<br />{{ addressLineTwo }}</p>
					<div class="profile-picture" :style="'background-image: url('+profilePictureUrl+');'"></div>
				</div>
				<div class="contact">
					<div class="info">
						<SvgIcon icon="phone-icon" />
						<div>
							<p class="label">{{$t('tenant-profile.phone.label')}}</p>
							<a :href="`tel:`+phone" v-if="phone" class="phone">
								<span v-for="number in phone">
									{{ number }}
								</span>
							</a>
							<p v-else class="else">{{$t('tenant-profile.unknown-address.label')}}</p>
						</div>
					</div>
					<div class="info">
						<SvgIcon icon="mail-icon" />
						<div>
							<p class="label">{{$t('tenant-profile.email.label')}}</p>
							<a :href="`mailto:`+email" v-if="email">{{ email }}</a>
							<p v-else class="else">{{$t('tenant-profile.unknown-address.label')}}</p>
						</div>
					</div>
				</div>
				<div class="address">
					<p class="label">{{$t('tenant-profile.age.label')}}</p>
					<p v-if="age > 0">
						{{ age }} {{$t('tenant-profile.age.after')}}
					</p>
					<p v-else>
						{{ $t('tenant-profile.unknown-age.label') }}
					</p>
				</div>
				<div class="address" v-if="showAddress">
					<p class="label">{{$t('tenant-profile.current.label')}}</p>
					<p>{{ currentAddressLineOne }}</p>
					<p>{{ currentAddressLineTwo }}</p>
					<p>{{ currentAddressLineThree }}</p>
				</div>
				<div v-else class="address">
					<p class="label">{{$t('tenant-profile.current.label')}}</p>
					<p>{{ $t('tenant-profile.unknown-address.label') }}</p>

				</div>

				<div class="actions if-landlord" v-if="getTenantAccess === null">
					<a v-if="loaded" :href="'/contracts/digital-contract/select-property?tenant=' + tenantId + '&property=' + propertyId">
						<button class="button green">
							<simple-svg
								:filepath="'/images/SVG/Buttons/Contract.svg'"
								:width="'16px'"
								:height="'20px'"
							/>
							{{$t('button.contract.create')}}
						</button>
					</a>
				</div>
			</div>
			<div class="right-side">
				<div class="section">
					<!-- <h3>{{$t('tenant-profile.finances.headline')}}</h3> -->
					<div class="row finances">
						<div class="box single-box col-fifty">
							<div class="icon">
								<img src="/images/img/screening/nemid.png" v-if="!without_nemid">
								<img src="/images/img/screening/id-icon.svg" v-else>
							</div>
							<div class="info-box">
								<p v-if="!without_nemid">{{$t('tenant-profile.nemid.label')}}</p>
								<p v-else>{{$t('tenant-profile.not-nemid.label')}}</p>

								<p class="info" v-if="cpr">
									{{$t('tenant-profile.approved.label')}}
								</p>
								<p class="info not-validated" v-else-if="!validationFinished && without_nemid">
									{{$t('awaiting.verification.label')}}
								</p>
								<p class="info" v-else-if="validationFinished && without_nemid">
									{{$t('tenant-profile.approved.label')}}
								</p>
								<p class="info not-validated" v-else>
									{{$t('tenant-profile.unknown-address.label')}}
								</p>
							</div>
						</div>
						<div class="box single-box col-fifty">
							<div class="icon">
								<img src="/images/img/screening/cpr.png" v-if="!without_nemid">
								<img src="/images/img/screening/doc-icon.svg" v-else>
							</div>
							<div class="info-box">
								<p v-if="!without_nemid">{{$t('tenant-profile.cpr.label')}}</p>
								<p v-else>{{$t('tenant-profile.not-cpr.label')}}</p>

								<p class="info" v-if="cpr">
									{{$t('tenant-profile.approved.label')}}
								</p>
								<p class="info" v-else-if="without_nemid">
									{{$t('tenant-profile.personal-verification.documentation')}}
								</p>
								<p class="info not-validated" v-else>
									{{$t('tenant-profile.unknown-address.label')}}
								</p>
							</div>
						</div>

					</div>
					<div class="row finances">
						<div class="box single-box col-fifty">
							<div class="icon">
								<img src="/images/img/screening/income.png">
							</div>
							<div class="info-box">
								<p>{{$t('tenant-profile.finances.income')}}</p>
								<p class="info" v-if="validationFinished && income != null">{{$t('tenant-profile.finances.currency')}} {{ (income ? income : '0') | toCurrency }}</p>
								<p class="info not-validated" v-else>{{$t('awaiting.verification.label')}}</p>
							</div>

						</div>
						<div class="col-fifty box single-box">
							<div class="icon">
								<img src="/images/img/screening/economic.png">
							</div>
							<div class="info-box">
								<p>
<!--									<template v-if="isLandlord">-->
<!--										{{$t('tenant-profile.finances.status')}}-->
<!--									</template>-->
									<template>
										{{$t('tenant-profile.finances.status-landlord')}}
									</template>
								</p>
								<p class="info">
										<template>
											<template v-if="rki == 'no_record'">
												<SvgIcon icon="checkmark-circle" />
												{{$t('tenant-profile.finances-tenant.no-record')}}
											</template>
											<template v-if="rki == 'has_records'">
												<SvgIcon icon="error-circle" />
												{{$t('tenant-profile.finances-tenant.has-record')}}
											</template>
											<template v-if="rki == 'expat'">
												{{$t('tenant-profile.finances.rki-expat')}}
											</template>
											<template v-if="!rki">
												<span style="opacity: 0.25;">{{$t('tenant-profile.finances.none')}}</span>
											</template>
										</template>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div class="section box">
					<div class="box-top">
						<div class="icon">
							<img src="/images/img/screening/work.png">
						</div>
						<div class="info-box">
							<!-- Shows if tenant is in job -->
							<div v-if="validationFinished">
								<h3>{{$t('tenant-profile.work.headline')}}</h3>
								<div class="student active" v-if="employmentType">
									<span class="dot"></span>
									<span>{{$t('tenant-profile.work.active-employee')}}</span>
								</div>
								<div class="student" v-else>
									<span class="dot"></span>
									<span>{{$t('tenant-profile.work.inactive-employee')}}</span>
								</div>
							</div>
							<div v-else>
								<p class="not-validated">{{$t('tenant-profile.work.headline')}}</p>
								<p class="info not-validated">{{$t('awaiting.verification.label')}}</p>
							</div>
						</div>
					</div>

					<div v-if="validationFinished && company" class="row">
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.work.type')}}</p>
							<p class="info">
								<span v-if="employmentType">{{ $t(employmentType) }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.work.company')}}</p>
							<p class="info">
								<span v-if="company">{{ company }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
					</div>
					<div v-if="validationFinished && company" class="row">
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.work.position')}}</p>
							<p class="info">
								<span v-if="position">{{ position }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.work.date')}}</p>
							<p class="info">
								<span v-if="employmentDateFormatted">{{ employmentDateFormatted }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
					</div>
				</div>

				<div class="section box">
					<div class="box-top">
						<div class="icon">
							<img src="/images/img/screening/study.png">
						</div>
						<div class="info-box">
							<!-- Shows if tenant is an active student-->
							<div v-if="validationFinished">
								<h3>{{$t('tenant-profile.education.headline')}}</h3>
								<div class="student active" v-if="activeStudent">
									<span class="dot"></span>
									<span>{{$t('tenant-profile.education.active-student')}}</span>
								</div>
								<div class="student" v-else>
									<span class="dot"></span>
									<span>{{$t('tenant-profile.education.graduated')}}</span>
								</div>
							</div>
							<div v-else>
								<p class="not-validated">{{$t('tenant-profile.education.headline')}}</p>
								<p class="not-validated info">{{$t('awaiting.verification.label')}}</p>
							</div>
						</div>
					</div>
					<div v-if="validationFinished && activeStudent" class="row">
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.education.institution')}}</p>
							<p class="info">
								<span v-if="institution">{{ institution }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.education.start-date')}}</p>
							<p class="info">
								<span v-if="educationStartDateFormatted">{{ educationStartDateFormatted }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
					</div>
					<div v-if="validationFinished && activeStudent" class="row">
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.education.study')}}</p>
							<p class="info">
								<span v-if="study">{{ study }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
						<div class="col-fifty inner-col">
							<p>{{$t('tenant-profile.education.graduation-date')}}</p>
							<p class="info">
								<span v-if="educationEndDateFormatted">{{ educationEndDateFormatted }}</span>
								<span v-else style="opacity: 0.25">{{$t('general.not-defined.label')}}</span>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

	import {mapGetters} from 'vuex';
	import {store} from '../../store/index';
    import Vue from 'vue';


    import SvgIcon from '../../components/Svg.vue';

    Vue.filter('formatDate', function(value) {
        if (value) {
            return moment(String(value)).format('DD-MM-YYYY')
        }
    });

    export default {
    	computed: {
    		...mapGetters([
    			'getToken',
                'getTenantAccess'
    		]),
    		tenantId() {
    			return this.$route.params.id
    		},
    		splitedList(){
    			let newArr = [...this.phone]
			      newArr.map(el => {
			      	return el = el.split('')
			      })
			      return newArr
    		}
    	},
    	components: {
    		SvgIcon
    	},
    	data: () => ({
    		loaded: false,
    		propertyId: false,
    		showAddress: false,
    		profilePictureUrl: '',
    		isTenant: 			false,
    		validationFinished: false,
    		rki: '',

			firstName: 			false,
			lastName: 			'',
			age: 				'',
			phone: 				'',
			email: 				'',

			addressLineOne: 	'',
			addressLineTwo: 	'',

			currentAddressLineOne: '',
			currentAddressLineTwo: '',
			currentAddressLineThree: '',

			income: 				'',
			employmentType: 	'',
			company: 			'',
			position: 			'',
			employmentDate: 	'',
			activeEmployee: 	false,
			activeStudent: 		false,
			institution: 		'',
			educationStartDate: '',
			educationEndDate: 	'',
			study: 				'',

			educationEndDateFormatted: '',
			educationStartDateFormatted: '',
			employmentDateFormatted: '',

			cpr: '',
			without_nemid: '',
			country: '',

		}),

		methods: {
			formatDate(date) {
				return date ? moment(String(date)).format('DD-MM-YYYY') : ''
			},
			fetchTenant() {
				var uri = this.$route.params.id
					? 'api/tenant/' + this.$route.params.id
					: 'api/my-profile';

				// In certain screening cases we want to display an empty profile.
				// If id=0, we leave the view as it as, but don't attempt to fetch data
				if (!Number(this.$route.params.id) && uri != 'api/my-profile') {
					axios({
						method: 'GET',
						url: window.config.apiUrl + 'api/property/' + this.$route.query.property,

					}).then(response => {
						var property = response.data;
						this.firstName = property.address.replace(/,.*?$/, '');
						this.addressLineOne = property.zip_code + ' ' + property.city;
					});
					return;
				}

				var self = this;
				axios({
					method: 'GET',
					url: window.config.apiUrl + uri,

				}).then(response => {

					if (response.data.userInfo.image_url) {
						this.profilePictureUrl = window.config.apiUrl + 'storage/' + response.data.userInfo.image_url;
					}

					var property = response.data.property;
					if (property) {
						this.propertyId = property.id;
						this.addressLineOne = property.address.replace(/,.*?$/, '');
						this.addressLineTwo = property.zip_code + ' ' + property.city;
						this.addressLineThree = property.country;
					}
					this.loaded = true;
					self.isTenant = true;
					self.age = response.data.age;
					self.phone = response.data.userInfo.phone;
					self.email = response.data.user.email;
					this.showAddress = response.data.userInfo.address ? true : false;
					self.currentAddressLineOne = response.data.userInfo.address;
					self.currentAddressLineTwo = response.data.userInfo.zipcode + ' ' + response.data.userInfo.city;
					self.currentAddressLineThree = response.data.userInfo.country;
					self.firstName = response.data.userInfo.full_name;

					self.cpr = response.data.userInfo.pnr;
					self.without_nemid = response.data.userInfo.without_nemid;
					self.country = response.data.userInfo.country;

					self.income = response.data.screening.income;
					self.employmentType = response.data.jobType;
					self.employmentDate = response.data.screening.job_employment_date;
					self.company = response.data.screening.job_company;
					self.position = response.data.screening.job_position;
					self.institution = response.data.screening.education_institution;
					self.educationStartDate = response.data.screening.education_start;
					self.educationEndDate = response.data.screening.education_end;
					self.study = response.data.screening.education_study;
					self.activeStudent = response.data.activeStudent;
					self.validationFinished = uri == 'api/my-profile' ? true : response.data.verificationCompleted;
					self.rki = response.data.screening.rki;

					this.employmentDateFormatted = this.formatDate(this.employmentDate);
					this.educationStartDateFormatted = this.formatDate(this.educationStartDate);
					this.educationEndDateFormatted = this.formatDate(this.educationEndDate);
				});
			}
		},
		created() {
			this.fetchTenant();
		}
    }

</script>
<style></style>
